(() => {
  if (window.CollectionTabsSection) return;

  class CollectionTabsSection {
    constructor(section) {
      if (!section) return;

      this.section = section;
      this.initTabs();
      this.initSliders();
      this.initAddToCart();
    }

    initAddToCart() {
      // Capture phase: when the quick view popup is disabled for this card,
      // stop the click from ever reaching the global popup handler and add
      // the first available variant to the cart directly instead.
      this.section.addEventListener(
        'click',
        (e) => {
          const btn = e.target.closest('.buttonaddtocart button');
          if (!btn || btn.dataset.quickViewPopup !== 'false' || btn.disabled) return;

          e.stopPropagation();
          e.preventDefault();

          const productCard = btn.closest('.product-grid-card');
          const submitButton = productCard && productCard.querySelector('form .single_button');
          if (submitButton && !submitButton.disabled) {
            submitButton.click();
          }
        },
        true
      );
    }

    initTabs() {
      const tabLinks = this.section.querySelectorAll('.collection-tabs-tab-link');
      const tabContents = this.section.querySelectorAll('.collection-tabs-content');

      tabLinks.forEach((tab) => {
        tab.addEventListener('click', (e) => {
          const item = e.currentTarget.closest('.collection-tabs-tab-item');
          const target = item.getAttribute('data-tab-heading');

          this.section.querySelectorAll('.collection-tabs-tab-item').forEach((el) => {
            el.classList.remove('current');
          });
          item.classList.add('current');

          tabContents.forEach((el) => el.classList.remove('current'));
          const activeContent = this.section.querySelector(
            `.collection-tabs-content[data-tab-content="${target}"]`
          );

          if (activeContent) {
            activeContent.classList.add('current');
            this.updateSlider(activeContent);
          }
        });
      });
    }

    initSliders() {
      this.section.querySelectorAll('.collectionTabsSlider').forEach((container) => {
        if (container.dataset.initialized === 'true') return;
        container.dataset.initialized = 'true';
        this.buildSwiper(container);
      });
    }

    buildSwiper(container) {
      const loop = container.dataset.loop === 'true';
      const autoplayEnabled = container.dataset.autoplay === 'true';
      const time = parseInt(container.dataset.autoplayTime || 0, 10) * 1000;
      const showNav = container.dataset.navigation === 'true';
      const paginationDesktop = container.dataset.paginationDesktop === 'true';
      const paginationMobile = container.dataset.paginationMobile === 'true';
      const isMobileViewport = window.innerWidth < 749;
      const showPagination = isMobileViewport ? paginationMobile : paginationDesktop;

      const halfSlide = container.dataset.halfSlide === 'true';

      let slidesPerView = (parseFloat(container.dataset.slidePerView));

      if (isMobileViewport) {
        slidesPerView = (parseFloat(container.dataset.mSlidePerView));
        if (halfSlide) slidesPerView += 0.2;
      } else if (window.innerWidth < 990) {
        slidesPerView = 2.5;
      } else if (halfSlide) {
        slidesPerView += 0.5;
      }

      const panel = container.closest('.collection-tabs-content');
      const navigation = showNav
        ? {
            nextEl: panel.querySelector('.swiper-button-next'),
            prevEl: panel.querySelector('.swiper-button-prev'),
          }
        : false;

      const pagination = showPagination
        ? {
            el: panel.querySelector('.swiper-pagination'),
            clickable: true,
          }
        : false;

      const autoplay = autoplayEnabled
        ? {
            delay: time,
            disableOnInteraction: false,
          }
        : false;

      new Swiper(container, {
        loop,
        slidesPerView,
        spaceBetween: 4,
        navigation,
        pagination,
        autoplay,
        observer: true,
        observeParent: true,
        breakpoints: {
          768: { spaceBetween: 10 },
          990: { spaceBetween: 12 },
          1025: { spaceBetween: 20 },
        },
      });
    }

    updateSlider(panel) {
      const container = panel.querySelector('.collectionTabsSlider');
      if (container && container.swiper) {
        container.swiper.update();
      }
    }
  }

  window.CollectionTabsSection = CollectionTabsSection;

  const init = () => {
    document.querySelectorAll('.section-collection-tabs').forEach((section) => new CollectionTabsSection(section));
  };

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
